import { useFieldArray, Control } from 'react-hook-form'

import { ChargeRecurrenceBodyModalForm } from 'templates/Charge/interface'

import {
  configurePlan,
  ConfigurePlanProps
} from '../BodyModalNewChargeOrRecurrence.utils'

interface UseConfigurePlanProps {
  control: Control<ChargeRecurrenceBodyModalForm>
  replaceDiscounts?: (discounts: any[]) => void
}

/**
 * Hook customizado que encapsula a lógica de configuração de planos
 * Gerencia os useFieldArray para descontos e identificadores internos
 */
export const useConfigurePlan = ({
  control,
  replaceDiscounts: externalReplaceDiscounts
}: UseConfigurePlanProps) => {
  // useFieldArray para gerenciar descontos (sempre chamado para seguir as regras dos hooks)
  const internalDiscountsFieldArray = useFieldArray({
    control,
    name: 'discounts'
  })

  // Usar replaceDiscounts externo se disponível, senão usar interno
  const replaceDiscounts =
    externalReplaceDiscounts || internalDiscountsFieldArray.replace

  // useFieldArray para gerenciar identificadores internos
  const { replace: replaceInternalIdentifiers } = useFieldArray({
    control,
    name: 'internalIdentifiers'
  })

  /**
   * Função que configura o plano com os useFieldArray já configurados
   */
  const configureSelectedPlan = async (
    props: Omit<
      ConfigurePlanProps,
      'replaceDiscounts' | 'replaceInternalIdentifiers'
    >
  ) => {
    if (!replaceDiscounts) {
      return
    }

    return configurePlan({
      ...props,
      replaceDiscounts,
      replaceInternalIdentifiers
    })
  }

  return {
    configureSelectedPlan,
    replaceDiscounts,
    replaceInternalIdentifiers
  }
}
